<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h1 class="primary--text">{{ titulo_oferta }}</h1>
                <p class="primary--text">{{ institucion }} - {{ establecimiento }}</p>
                <p class="primary--text">{{ unidad }}</p>
                <p class="primary--text">Fecha límite {{ fecha_limite }}</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <EstadoProcesoStepper :estado="estadoProceso" :color="colorProceso" />
            </v-col>
        </v-row>
        <v-row class="mt-4" v-if="estadoProceso === 'Evaluación'">
            <v-col cols="12" class="d-flex align-center">
                <img src="/img/icon-paste.svg" class="mr-2" width="24" height="24" alt="evaluaciones icon" />
                <span class="text-h6 font-weight-bold primary--text">Evaluaciones</span>
            </v-col>
        </v-row>

        <v-row class="mt-2" v-if="estadoProceso === 'Evaluación'">
            <v-col v-for="evaluacion in evaluacionesVista" :key="evaluacion.id" cols="12" md="6" lg="4" class="d-flex">
                <CardEvaluacion :titulo="evaluacion.titulo" :tipoDePrueba="evaluacion.tipoDePrueba"
                    :inicia="evaluacion.inicia" :finaliza="evaluacion.finaliza" :duracion="evaluacion.duracion"
                    :estado="evaluacion.estadoBoton" @click-action="onEvaluacionClick(evaluacion)" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="d-flex justify-center">
                <v-btn color="primary" outlined class="text-none rounded-xl" max-width="230" elevation="0"
                    @click="regresar">Regresar</v-btn>
            </v-col>
        </v-row>

        <AppDialog v-model="mostrarModalDetalle" title="Detalle de la entrevista" width="850">
            <template v-slot:body>
                <div class="text-center mb-6 mt-2">
                    <span class="text-subtitle-1 primary--text">Tu entrevista ha sido programada con la siguiente
                        información</span>
                </div>

                <v-row justify="center" class="mb-4">
                    <v-col cols="11" sm="8">
                        <div class="d-flex align-center mb-3">
                            <v-icon color="primary" size="20" class="mr-3">mdi-calendar-blank-outline</v-icon>
                            <span class="primary--text" style="font-size: 16px;">Fecha: {{ detalleEntrevista.fecha
                            }}</span>
                        </div>
                        <div class="d-flex align-center mb-3">
                            <v-icon color="primary" size="20" class="mr-3">mdi-clock-outline</v-icon>
                            <span class="primary--text" style="font-size: 16px;">Hora: {{ detalleEntrevista.hora
                            }}</span>
                        </div>
                        <div class="d-flex align-center mb-3">
                            <v-icon color="primary" size="20" class="mr-3">mdi-information-outline</v-icon>
                            <span class="primary--text" style="font-size: 16px;">Indicaciones: {{
                                detalleEntrevista.indicaciones }}</span>
                        </div>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:actions>
                <v-row justify="center" class="pb-4">
                    <v-btn color="primary" dark class="rounded-xl px-12 py-5 text-none font-weight-bold" elevation="0"
                        @click="mostrarModalDetalle = false">
                        Aceptar
                    </v-btn>
                </v-row>
            </template>
        </AppDialog>
    </v-container>
</template>
<script>
import EstadoProcesoStepper from './components/EstadoProcesoStepper.vue';
import CardEvaluacion from './components/CardEvaluacion.vue';
export default {
    components: {
        EstadoProcesoStepper,
        CardEvaluacion,
    },
    props: {

    },
    data() {
        return {
            titulo_oferta: "",
            unidad: "",
            establecimiento: "",
            institucion: "",
            fecha_limite: "",
            estadoProceso: 'Postulado',
            colorProceso: 'verde',
            mostrarModalDetalle: false,
            detalleEntrevista: {
                fecha: '',
                hora: '',
                indicaciones: ''
            },
            evaluaciones: []
        }
    },
    methods: {
        onEvaluacionClick(evaluacion) {
            if (evaluacion.raw.id_tipo_evaluacion === 1) {
                this.detalleEntrevista = {
                    fecha: this.formatFecha(evaluacion.raw.fecha_inicio),
                    hora: this.formatHora(evaluacion.raw.hora_inicio),
                    indicaciones: evaluacion.raw.indicaciones
                };
                this.mostrarModalDetalle = true;
            } else {
                this.$router.push({ name: 'evaluacion-instrucciones', params: {idEvaluacion: evaluacion.raw.id_solicitud_evaluacion } });
            }
        },
        formatFecha(fechaISO) {
            if (!fechaISO) return '';
            const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
            const [year, month, day] = fechaISO.split('T')[0].split('-').map(Number);
            return `${day} ${meses[month - 1]}, ${year}`;
        },
        formatHora(horaStr) {
            if (!horaStr) return '';
            const [hh, mm] = horaStr.split(':').map(Number);
            let hora12 = hh % 12;
            if (hora12 === 0) hora12 = 12;
            const ampm = hh >= 12 ? 'PM' : 'AM';
            return `${String(hora12).padStart(2, '0')}:${String(mm).padStart(2, '0')} ${ampm}`;
        },
        formatFechaHora(fechaISO, horaStr) {
            if (!fechaISO || !horaStr) return '';
            return `${this.formatFecha(fechaISO)} ${this.formatHora(horaStr)}`;
        },
        formatDuracion(horas, minutos) {
            const partes = [];
            if (horas) partes.push(`${horas} ${horas === 1 ? 'hora' : 'horas'}`);
            if (minutos) partes.push(`${minutos} ${minutos === 1 ? 'minuto' : 'minutos'}`);
            return partes.join(' ');
        },
        formatFechaLimite(fechaISO) {
            if (!fechaISO) return '';
            const [year, month, day] = fechaISO.split('T')[0].split('-');
            return `${day}-${month}-${year}`;
        },
        regresar() {
            if (window.history.length > 1 && document.referrer.includes(window.location.host)) {
                this.$router.back();
            } else {
                this.$router.push({ name: 'mis-postulaciones' });
            }
        }
    },
    computed: {
        evaluacionesVista() {
            return this.evaluaciones.map((e) => ({
                id: e.id_solicitud_evaluacion,
                titulo: e.nombre,
                tipoDePrueba: e.nombre_tipo_evaluacion,
                inicia: this.formatFechaHora(e.fecha_inicio, e.hora_inicio),
                finaliza: this.formatFechaHora(e.fecha_fin, e.hora_fin),
                duracion: this.formatDuracion(e.hora_duracion_eval, e.minuto_duracion_eval),
                estadoBoton: e.id_tipo_evaluacion === 1
                    ? 'Ver detalles'
                    : (e.iniciar_evaluacion ? 'Iniciar evaluación' : ''),
                raw: e
            }));
        }
    },
    async mounted() {
        const id_oferta = this.$route.params.id;
        try {
            const response = await this.services.evaluacionContratacion.getProcesoContratacion(id_oferta);
            if (response?.data?.data) {
                this.titulo_oferta = response.data.data.titulo_oferta;
                this.institucion = response.data.data.institucion;
                this.establecimiento = response.data.data.establecimiento;
                this.unidad = response.data.data.unidad_organizativa;
                this.fecha_limite = this.formatFechaLimite(response.data.data.fecha_limite);
                this.estadoProceso = response.data.data.estado;
                this.colorProceso = response.data.data.color;
                this.evaluaciones = response.data.data.evaluaciones || [];
            }
        } catch (e) {
            console.log({ e });
        }
    }
}
</script>
<style scoped></style>